// extracted by mini-css-extract-plugin
export default {"ff_bubble":"BubbleButton_ff_bubble__wMlzj","ff_bubble__button":"BubbleButton_ff_bubble__button__IJA8c","ff_bubble__text":"BubbleButton_ff_bubble__text__I556L"};